import {
  Estate,
  House,
  Condominium,
  Plot,
  Cottage,
  Farm,
  HousingCooperative,
  VitecEstateType,
  CommercialProperty,
} from "@habity/types/vitec";

export const isHouse = (
  estate_data: Estate,
  estate_type: VitecEstateType
): estate_data is House => {
  return estate_type === "House";
};

export const isCondominium = (
  estate_data: Estate,
  estate_type: VitecEstateType
): estate_data is Condominium => {
  return estate_type === "Condominium";
};

export const isCottage = (
  estate_data: Estate,
  estate_type: VitecEstateType
): estate_data is Cottage => {
  return estate_type === "Cottage";
};

export const isFarm = (
  estate_data: Estate,
  estate_type: VitecEstateType
): estate_data is Farm => {
  return estate_type === "Farm";
};

export const isHousingCooperative = (
  estate_data: Estate,
  estate_type: VitecEstateType
): estate_data is HousingCooperative => {
  return estate_type === "HousingCooperative";
};

export const isPlot = (
  estate_data: Estate,
  estate_type: VitecEstateType
): estate_data is Plot => {
  return estate_type === "Plot";
};

export const isCommercialProperty = (
  estate_data: Estate,
  estate_type: VitecEstateType
): estate_data is CommercialProperty => {
  return estate_type === "CommercialProperty";
};

// export const isPremises = (
//   estate_data: Estate,
//   estate_type: VitecEstateType
// ): estate_data is Premises => {
//   return estate_type === 'Premises';
// };

// export const isProject = (
//   estate_data: Estate,
//   estate_type: VitecEstateType
// ): estate_data is Project => {
//   return estate_type === 'Project';
// };
